(function () {
  const root = document.querySelector('[data-folifree-product]');
  if (!root) return;

  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const cartClearUrl = root.dataset.cartClearUrl || '/cart/clear.js';

  let currentQuantity = 1;
  let selectedVariantId = Number(root.dataset.defaultVariantId || 0);
  let currentUnitPrice = Number(root.dataset.defaultPrice || 0);
  let currentComparePrice = Number(root.dataset.defaultCompare || 0);

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? '.' : thousands;
    decimal = decimal == null ? ',' : decimal;
    if (isNaN(number) || number == null) return '0';
    const parts = (number / 100.0).toFixed(precision).split('.');
    const major = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const minor = parts[1] ? decimal + parts[1] : '';
    return major + minor;
  }

  function formatMoney(cents) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = moneyFormat.match(placeholder) || ['{{amount}}', 'amount'];
    let value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 0, '.', ',');
    }
    return moneyFormat.replace(placeholder, value);
  }

  function updatePrices() {
    const priceEl = document.getElementById('bundle-price');
    const compareEl = document.getElementById('bundle-compare');
    const mobilePriceEl = document.getElementById('mobile-sticky-price');
    const savingsEl = document.getElementById('bundle-savings');
    const total = currentUnitPrice * currentQuantity;
    const compare = currentComparePrice * currentQuantity;

    if (priceEl) priceEl.textContent = formatMoney(total);
    if (compareEl) {
      compareEl.textContent = formatMoney(compare);
      compareEl.classList.toggle('hidden', !currentComparePrice || currentComparePrice <= currentUnitPrice);
    }
    if (mobilePriceEl) mobilePriceEl.textContent = formatMoney(total);
    if (savingsEl && currentComparePrice > currentUnitPrice) {
      savingsEl.textContent = 'Ahorras ' + formatMoney(compare - total) + ' hoy';
    }
  }

  window.changeImage = function (imgSrc, element) {
    const mainImg = document.getElementById('main-product-img');
    if (!mainImg) return;
    mainImg.style.opacity = '0.4';
    setTimeout(function () {
      mainImg.src = imgSrc;
      mainImg.style.opacity = '1';
    }, 150);

    document.querySelectorAll('.thumb-btn').forEach(function (btn) {
      btn.classList.remove('active-thumb');
      btn.classList.add('opacity-70');
    });
    if (element) {
      element.classList.add('active-thumb');
      element.classList.remove('opacity-70');
    }
  };

  window.selectBundle = function (variantId, salePrice, comparePrice, card) {
    selectedVariantId = Number(variantId);
    currentUnitPrice = Number(salePrice);
    currentComparePrice = Number(comparePrice);
    document.querySelectorAll('.bundle-card').forEach(function (el) {
      el.classList.remove('is-selected', 'bg-surface-container-high/60');
      el.classList.add('bg-surface-container-lowest');
    });
    if (card) {
      card.classList.add('is-selected', 'bg-surface-container-high/60');
      card.classList.remove('bg-surface-container-lowest');
    }
    updatePrices();
  };

  window.updateQty = function (delta) {
    currentQuantity += delta;
    if (currentQuantity < 1) currentQuantity = 1;
    if (currentQuantity > 10) currentQuantity = 10;
    const qtyDisplay = document.getElementById('quantity-display');
    if (qtyDisplay) qtyDisplay.textContent = currentQuantity;
    updatePrices();
  };

  async function addToCart(properties) {
    if (!selectedVariantId) {
      window.location.hash = 'producto';
      return;
    }

    try {
      await fetch(cartClearUrl, { method: 'POST', headers: { Accept: 'application/json' } });
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: selectedVariantId,
              quantity: currentQuantity,
              properties: properties || {}
            }
          ]
        })
      });

      if (!response.ok) {
        const error = await response.json();
        alert(error.description || error.message || 'No se pudo agregar el producto al carrito.');
        return;
      }

      window.location.href = checkoutUrl;
    } catch (error) {
      alert('No se pudo completar el pedido. Intenta de nuevo.');
    }
  }

  window.triggerCheckout = function () {
    addToCart();
  };

  window.triggerCODCheckout = function () {
    addToCart({ _Metodo_de_pago: 'Contra entrega' });
  };
})();
